import { render } from "./AdvanceDirectives.vue?vue&type=template&id=45d503b0&ts=true"
import script from "./AdvanceDirectives.ts?vue&type=script&lang=ts&external"
export * from "./AdvanceDirectives.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__